class ScrollingImages {
  constructor() {
    this.initialize();
    this.scrollEnabled = true;
    this.scroll = 0;
    this.animate = this.animate.bind(this);
    this.animate();
    this.setOverlapObject = this.setOverlapObject.bind(this);
  }

  initialize() {
    this.scroll = 0;
    this.y = 10000;
    this.container = document.querySelector('[data-scrolling-images]')
    if(!this.container) {
      return this.scrollEnabled = false;
    }
    this.title = this.container.querySelector('[data-title]')
    this.titleContent = this.container.querySelector('[data-title-content]');
    if(this.title) {
      this.titlePos = this.title.getBoundingClientRect();
      if(this.titleContent) {
        this.titleContentPos = this.titleContent.getBoundingClientRect();
        this.titleTop = this.titleContentPos.top - window.innerHeight;
        this.titleBottom = (this.titleContentPos.top + this.titleContentPos.height) - window.innerHeight;
      }
    }

    this.scrollEnabled = true;
    this.items = this.container.querySelectorAll('[data-image]')
  }

  animate() {
    if(this.scrollEnabled && this.container) {
      const pos = this.container.getBoundingClientRect();
      const offset = (pos.top + window.innerHeight) - this.scroll;
      this.y = lerp(this.y, offset, 0.05);
      this.items.forEach((item) => {
        const speed = window.innerWidth < 768 ? item.getAttribute('data-speed') * 4 : item.getAttribute('data-speed')
        item.style.transform = `translate3d(0, ${this.y / speed}px, 0)`;
      })

      
      this.setOverlapObject();
      const hasOverlappingItems = this.hasOverlappingItems();

      if(this.title && this.titleContent) {
        if(hasOverlappingItems) {
          this.title.classList.add('hide')
        } else {
          this.title.classList.remove('hide')
        }
      }

      if(this.title && !this.titleContent) {
        const textShowPosition = window.innerWidth <= 768 ? this.titlePos.top + this.titlePos.height / 1.5 : this.titlePos.top + this.titlePos.height / 4;
        if(this.scroll > textShowPosition) {
          this.title.classList.add('hide')
        } else {
          this.title.classList.remove('hide')
        } 
      }
    }
    requestAnimationFrame(this.animate);
  }

  hasOverlappingItems () {
    const values = Object.values(this.intersectingItems);
    return values.find(value => value.intersecting == true)
  }

  setOverlapObject() {
    this.intersectingItems = {};

    this.items.forEach((item, index) => {
      const itemPos = item.getBoundingClientRect()
      if(itemPos.top < this.titleBottom + 50 && (itemPos.top + itemPos.height) > this.titleTop - 50) {
        this.intersectingItems[index] = {
          intersecting: true
        }
      } else {
        this.intersectingItems[index] = {
          intersecting: false
        }
      }
    })
  }

  onScroll(scroll) {
    this.scroll = scroll;
  }
}

const scrollingImages = new ScrollingImages();